document.addEventListener('DOMContentLoaded', function () {
  // Start feature-product-section slider
  // var featureProductSwiper = new Swiper(".feature-product-slider", {
  //   slidesPerView: 4,
  //   spaceBetween: 25,
  //   loop: false,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     0: {
  //       slidesPerView: 1,
  //       spaceBetween: 10,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 20,
  //     },
  //     1024: {
  //       slidesPerView: 4,
  //       spaceBetween: 25,
  //     }
  //   }
  // });

  // Start Video Block Slider
  var videoSwiper = new Swiper(".video-slide", {
    slidesPerView: 4,
    centeredSlides: false,
    spaceBetween: 25,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 25
      }
    }
  });

  // Play Video Function
  window.playVideo = function (index) {
    var thumbnail = document.getElementById('thumbnail-' + index);
    var videoElement = document.getElementById('video-element-' + index);

    if (thumbnail && videoElement) {
      thumbnail.style.display = 'none';
      videoElement.style.display = 'block';
      var video = videoElement.querySelector('video');
      if (video) video.play();
    }
  };

// about image-block slider
  var imageblockSlider = new Swiper(".image-slider", {
    slidesPerView: 4,
    spaceBetween: 25,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 25,
      }
    }
  });
  
});
